export default () => {
  const nuxtApp = useNuxtApp()

  return {
    emitterEmit: nuxtApp.$emitterEmit,
    emitterOn: nuxtApp.$emitterOn,
    emitterOff: nuxtApp.$emitterOff,
    emitterOnce: (eventName: any, cb: any) => {
      const handler = () => {
        if (typeof cb === 'function') {
          cb()
        }

        nuxtApp.$emitter.off(eventName, handler)
      }

      nuxtApp.$emitter.on(eventName, handler)
    }
  }
}
